import './CollapsibleCardList.scoped.scss'

export default function CollapsibleCardList({ children, initialLimit = 8, variant = 'flex' }) {
  const [expanded, setExpanded] = useState(false)

  const childArray = React.Children.toArray(children)
  const hasMore = childArray.length > initialLimit
  const displayChildren = expanded ? childArray : childArray.slice(0, initialLimit)

  return (
    <div className="collapsible-card-list">
      <div className={`collapsible-card-list-items variant-${variant}`}>
        {displayChildren}
      </div>
      {hasMore && (
        <button
          className="collapsible-card-list-toggle"
          onClick={() => setExpanded(!expanded)}
          type="button"
        >
          {expanded ? 'See less' : `See more (${childArray.length - initialLimit})`}
        </button>
      )}
    </div>
  )
}
